import { ChangeEventValue, Coords } from 'google-map-react';
import { render } from 'react-dom';

import SearchBox from 'dashboard/components/Map/SearchBox';
import { Place } from 'lib/interfaces/place';

// Zoom we apply when the user searches an address in the search box
const ADDRESS_SEARCH_ZOOM = 11;

export function usePlaceSearch(
  onPlaceSearch: (place: Place, address: string) => void,
  onChange: ({ bounds, center, marginBounds, size, zoom }: ChangeEventValue) => void,
  handleGoogleApiLoaded?: (map: google.maps.Map, maps: any) => void,
) {
  const onSearchPlacesChanged = (places: google.maps.places.PlaceResult[] | undefined) => {
    if (places?.length ?? 0 > 0) {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      const location: google.maps.LatLng = places[0].geometry.location;
      const center: Coords = {
        lat: location.lat(),
        lng: location.lng(),
      };

      onChange({
        center: center,
        zoom: ADDRESS_SEARCH_ZOOM,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        bounds: undefined,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        marginBounds: undefined,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        size: undefined,
      });
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      onPlaceSearch({ lat: center.lat, lng: center.lng }, places[0].formatted_address);
    }
  };

  const handleApiLoaded = (map: google.maps.Map, maps: any) => {
    const searchBoxDiv = document.createElement('div');
    render(
      <SearchBox placeholder='Search' onPlacesChanged={onSearchPlacesChanged} />,
      searchBoxDiv,
    );
    map.controls[maps.ControlPosition.TOP_LEFT].push(searchBoxDiv);

    if (handleGoogleApiLoaded) {
      handleGoogleApiLoaded(map, maps);
    }
  };

  return {
    handleGoogleApiLoaded: handleApiLoaded,
    onChange: onChange,
  };
}
